import { render, staticRenderFns } from "./newFormulaireDeCotation.vue?vue&type=template&id=708e1313&scoped=true"
import script from "./newFormulaireDeCotation.vue?vue&type=script&lang=js"
export * from "./newFormulaireDeCotation.vue?vue&type=script&lang=js"
import style0 from "./newFormulaireDeCotation.vue?vue&type=style&index=0&id=708e1313&prod&scoped=true&lang=css"
import style1 from "./newFormulaireDeCotation.vue?vue&type=style&index=1&id=708e1313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e1313",
  null
  
)

export default component.exports